import Hero from './components/Hero';
import ValueProposition from './components/ValueProposition';
import Services from './components/Services';
import Industries from './components/Industries';
import Process from './components/Process';
import CaseStudies from './components/CaseStudies';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import { useTheme } from '@/context/ThemeContext';

export default function Home() {
  const { isDark } = useTheme();
  return (
    <div className={`min-h-screen transition-colors duration-500 ${isDark ? 'bg-[#0D1B2A]' : 'bg-[#F5F8FA]'}`}>
      <Hero />
      <ValueProposition />
      <Services />
      <Industries />
      <Process />
      <CaseStudies />
      <FinalCTA />
      <Footer />
    </div>
  );
}